<template lang="pug">
    div
      lessonHeader
      lessonTitle
      groupTitle
      div.textvid
        VideoPlay
        initialText
      feedbackVideo
      lessonFooter
</template>

<script>

import lessonHeader from "@/components/lesson-header/lesson-header";
import lessonTitle from '@/components/lesson-title/lesson-title'
import approach from '@/components/approach/approach'
import groupTitle from '@/components/group-title/group-title'
import buttonNext from '@/components/button-next/button-next'
import initialText from '@/components/initial-text/initial-text'
import lessonFooter from "@/components/lesson-footer/lesson-footer"
import VideoPlay from "@/components/video/video";
import feedbackVideo from "@/components/feedback-modal/feedback-video";

export default {
  name: 'Video2',
  components:{
    approach,
    lessonHeader,
    lessonTitle,
    groupTitle,
    buttonNext,
    initialText,
    feedbackVideo,
    lessonFooter,
    VideoPlay
  }
}
</script>

<style scoped>
@import 'end-lesson.scss';
</style>
